import { Link } from 'react-router-dom';
import './Footer.css';
import {
  FOOTER_INSTAGRAM_ICON_URL,
  FOOTER_LINKEDIN_ICON_URL,
  FOOTER_LOGO_URL,
} from '../../config/cloudinaryBrandImages';
import { useScrollAnimation } from '../../hooks/useScrollAnimation';

const Footer = () => {
  const sectionRef = useScrollAnimation({ threshold: 0.2 });

  return (
    <footer className="footer" ref={sectionRef} data-track-section="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-left">
            <div className="footer-logo">
              <img
                src={FOOTER_LOGO_URL}
                alt="Databiqs"
                className="footer-logo-icon"
                loading="lazy"
                decoding="async"
              />
            </div>

            <p className="footer-tagline">
              Pushing the boundaries of technology,
              unleashing limitless innovation for a
              smarter future.
            </p>

            <div className="social-icons">
              <a
                href="https://www.linkedin.com/company/databiqs"
                target="_blank"
                rel="noopener noreferrer"
                className="social-icon"
                aria-label="LinkedIn"
                style={{
                  '--i': '#0A66C2',
                  '--j': '#004182',
                }}
              >
                <span className="icon">
                  <img
                    src={FOOTER_LINKEDIN_ICON_URL}
                    alt=""
                    aria-hidden="true"
                    loading="lazy"
                    decoding="async"
                  />
                </span>

                <span className="title">
                  LinkedIn
                </span>
              </a>

              <a
                href="https://www.instagram.com/databiqs/"
                target="_blank"
                rel="noopener noreferrer"
                className="social-icon"
                aria-label="Instagram"
                style={{
                  '--i': '#FF5F6D',
                  '--j': '#FFC371',
                }}
              >
                <span className="icon">
                  <img
                    src={FOOTER_INSTAGRAM_ICON_URL}
                    alt=""
                    aria-hidden="true"
                    loading="lazy"
                    decoding="async"
                  />
                </span>

                <span className="title">
                  Instagram
                </span>
              </a>
            </div>
          </div>

          <div className="footer-middle">
            <p className="footer-heading">
              Links
            </p>

            <ul className="footer-links">
             
              <li>
                <Link to="/services">
                  Services
                </Link>
              </li>

              <li>
                <Link to="/case-studies">
                  Case Studies
                </Link>
              </li>
              <li>
                <Link to="/about">About Us</Link>
              </li>

              <li>
                <Link to="/blog">Blog</Link>
              </li>

              <li>
                <Link to="/contact">Contact us</Link>
              </li>
            </ul>
          </div>

          <div className="footer-right">
            <p className="footer-heading">Contact Us</p>
            <div className="footer-contact-details" style={{ marginBottom: '1.5rem', color: 'rgba(255, 255, 255, 0.8)', fontSize: '0.9rem', lineHeight: '1.6' }}>
              <p>Email: <a href="mailto:support@databiqs.com" style={{ color: 'inherit' }}>support@databiqs.com</a></p>
              <p>Phone: <a href="tel:+16282657121" style={{ color: 'inherit' }}>+1 628 265 7121</a></p>
              <p>5900 Balcones Dr Ste 19747, Austin, TX 78731, USA</p>
            </div>
            <p className="footer-heading">
              Ready to connect?
            </p>
            <p className="footer-cta__text">
              Reach out with your goals, or book a session and we&apos;ll help you map the next step.
            </p>
            <div className="footer-cta__actions">
              <Link
                to="/contact"
                className="footer-cta__btn footer-cta__btn--primary"
                data-track-cta="contact-us"
              >
                Contact us
              </Link>
              <Link
                to="/book-consultation"
                className="footer-cta__btn footer-cta__btn--ghost"
                data-track-cta="book-consultation"
              >
                Book a consultation
              </Link>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p className="copyright">
            © 2024–2026 Databiqs. All rights reserved. | <Link to="/privacy-policy">Privacy Policy</Link> | <Link to="/terms">Terms of Service</Link>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
